/**
 * @generated SignedSource<<82914ad6c034417bb32609b0bbd82acd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultArticleDateContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"hooksArticleDateUtilsContent">;
  readonly " $fragmentType": "defaultArticleDateContent";
};
export type defaultArticleDateContent$key = {
  readonly " $data"?: defaultArticleDateContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultArticleDateContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultArticleDateContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksArticleDateUtilsContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "4f48f78f06f42e205d606a9971b73427";

export default node;
